<template>
  <div
    v-if="(players && players.length > 0) || loading"
    class="availability-wrapper d-flex flex-column flex-sm-row"
  >
    <div class="availability-label">
      <v-progress-circular
        v-if="loading"
        indeterminate
        width="2"
        size="15"
        color="rgba(0,0,0,0.5)"
      />
      <v-icon v-if="!loading" :color="iconColor" small>{{ icon }}</v-icon>
      {{ label }}
    </div>
    <div class="player-invite-tokens">
      <div
        v-if="!loading"
        :key="player.id"
        class="player-invite"
        v-for="player in players"
      >
        <v-menu nudge-top="35" close-delay="400">
          <template v-slot:activator="{ on }">
            <span
              v-on="on"
              class="availability-token left-expand"
              v-bind:class="{ loading: player.id === updatingId }"
              v-bind:style="{ backgroundColor: tokenColor }"
            >
              <span
                style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
              >
                {{ player.firstName }}
                {{ player.lastName }}
              </span>

              <v-progress-circular
                class="ml-2"
                indeterminate
                width="2"
                size="15"
                color="rgba(0,0,0,0.5)"
              />
            </span>
          </template>
          <EventRowAvailabilityActionsModal
            :playerId="player.id"
            :event="event"
            @setPlayerAvailability="invitePlayer"
          />
        </v-menu>
      </div>
      <div class="player-invite" v-if="!loading && players.length > 1">
        <v-menu nudge-top="35" close-delay="400">
          <template v-slot:activator="{ on }">
            <span
              v-on="on"
              class="availability-token left-expand"
              v-bind:class="{ loading: updatingId === 'all' }"
              v-bind:style="{ backgroundColor: tokenColor }"
            >
              <span
                style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
              >
                <v-icon>mdi-plus</v-icon>
                Invite All
              </span>

              <v-progress-circular
                class="ml-2"
                indeterminate
                width="2"
                size="15"
                color="rgba(0,0,0,0.5)"
              />
            </span>
          </template>
          <EventRowAvailabilityActionsModal
            :playerId="'all'"
            :event="event"
            @setPlayerAvailability="inviteAllUninvitedPlayers"
          />
        </v-menu>
      </div>
    </div>
  </div>
</template>
<script>
import { i18n } from "@/plugins/i18n";
import {
  inviteAllPlayersToEvent,
  invitePlayerToEvent,
  updatePlayerAvailability
} from "@/helpers/api";
import { ModuleTypes } from "@/store/ModuleTypes";
import { mapActions } from "vuex";
import { SnackbarMutationTypes } from "@/views/academy/common/snackbar/SnackbarMutationTypes";
import EventRowAvailabilityActionsModal from "./EventRowAvailabilityActionsModal.vue";

export default {
  name: "EventRowNotInvitedAvailability",
  components: { EventRowAvailabilityActionsModal },
  props: {
    players: {
      type: Array,
      default: function() {
        return [];
      }
    },
    label: {
      type: String
    },
    icon: {
      type: String,
      default: "mdi-dots-vertical"
    },
    iconColor: {
      type: String,
      default: "black"
    },
    tokenColor: {
      type: String,
      default: "black"
    },
    event: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    updatingId: "",
    iconYes: "mdi-check-bold",
    iconNo: "mdi-cancel",
    iconUnknown: "mdi-help"
  }),
  methods: {
    async invitePlayer({ status, playerId, event }) {
      this.updatingId = playerId;
      const statuses = { Yes: "Accepted", No: "Declined", Unknown: "Pending" };
      const resp = await invitePlayerToEvent(
        this.event.id,
        playerId,
        statuses[status]
      );
      if (resp.success) {
        event.details.playerInvites.push(resp.playerInvite);
        this.$emit("removePlayer", playerId);
      } else {
        this.SHOW_SNACKBAR({
          text: i18n.tc("snackbar_message.save_failed"),
          timeout: 5000,
          color: "error"
        });
      }
      this.updatingId = "";
    },
    async inviteAllUninvitedPlayers({ status, playerId, event }) {
      this.updatingId = playerId;
      const statuses = { Yes: "Accepted", No: "Declined", Unknown: "Pending" };
      const resp = await inviteAllPlayersToEvent(
        this.event.id,
        statuses[status]
      );
      if (resp.success) {
        event.details.playerInvites = event.details.playerInvites.concat(
          resp.playerInvites
        );
        this.$emit("removeAllPlayers");
      } else {
        this.SHOW_SNACKBAR({
          text: i18n.tc("snackbar_message.save_failed"),
          timeout: 5000,
          color: "error"
        });
      }
      this.updatingId = "";
    },
    ...mapActions(ModuleTypes.SNACKBAR, {
      SHOW_SNACKBAR: SnackbarMutationTypes.SHOW_SNACKBAR
    })
  }
};
</script>
<style scoped>
.availability-wrapper {
}

.availability-label {
  font-size: 15px;
  font-weight: 500;
  min-width: 140px;
  display: inline-block;
  line-height: 25px;
}

.availability-label .v-icon {
  margin-top: -1px;
}

.availability-token {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
  background-color: #ddd;
  padding: 5px 0 5px 10px;
  border-radius: 20px;
  margin-bottom: 5px;
  margin-right: 5px;
  width: 140px;
}

.availability-token:hover {
  opacity: 0.8;
}

.availability-token .v-progress-circular {
  visibility: hidden;
}

.availability-token.loading {
  padding-left: 8px;
}

.availability-token.loading .v-progress-circular {
  visibility: visible;
}

.player-invite-tokens {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.player-invite-tokens .player-invite {
  white-space: nowrap;
  display: inline-block;
}

.player-invite-note {
  color: #666666;
  font-style: italic;
  font-size: 11px;
}

.availability-selectors {
  overflow: hidden !important;
}
</style>
